
// import React from 'react';
// import styled from 'styled-components';
// import transferHero from '../Images/domaintransferimg.jpg'; // Replace with actual image path

// const Hero = styled.section`
//   background-image: url(${transferHero});
//   background-size: cover;
//   background-position: center;
//   color: white;
//   padding: 120px 20px;
//   text-align: center;
//   position: relative;
  
//   &::before {
//     content: '';
//     position: absolute;
//     top: 0;
//     left: 0;
//     width: 100%;
//     height: 100%;
//     background: rgba(0, 0, 0, 0.5);
//     z-index: 0;
//   }

//   > * {
//     position: relative;
//     z-index: 1;
//   }
// `;

// const HeroTitle = styled.h1`
//   font-size: 3rem;
//   margin-bottom: 20px;
//   text-shadow: 2px 2px 6px rgba(0, 0, 0, 0.6);
//     text-transform:uppercase;
// `;

// const Section = styled.section`
//   padding: 60px 20px;
//   max-width: 1100px;
//   margin: auto;
//   text-align: center;

//   h2{
//     color:#2B32B2;
//     font-size:2rem;
//   }
// `;

// const Input = styled.input`
//   padding: 12px;
//   margin: 10px;
//   border: 1px solid #ccc;
//   border-radius: 5px;
//   width: 250px;
// `;

// const Button = styled.button`
//   background-color: #007bff;
//   color: white;
//   padding: 12px 25px;
//   margin-top: 15px;
//   border: none;
//   border-radius: 5px;
//   cursor: pointer;
//   font-size: 1rem;
//   transition: background 0.3s;

//   &:hover {
//     background-color: #0056b3;
//   }
// `;

// const Grid = styled.div`
//   display: grid;
//   grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
//   gap: 30px;
//   margin-top: 40px;
// `;

// const FeatureCard = styled.div`
//   background: #f8f9fa;
//   padding: 25px;
//   border-radius: 10px;
//   box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
//   text-align: left;

//   h3 {
//     font-size: 1.25rem;
//     color: #007bff;
//   }

//   p {
//     font-size: 0.95rem;
//     color: #333;
//     margin-top: 10px;
//   }
// `;

// const DomainTransferPage = () => {
//   return (
//     <>
//       <Hero>
//         <HeroTitle>Elexdon Host Domain Transfer</HeroTitle>
//         <p>Transfer now to extend your domain by 1 year!*</p>
//       </Hero>

//       <Section>
//         <h2>Single Domain Transfer</h2>
//         <Input placeholder="example.com" />
//         <Input placeholder="Epp Code / Auth Code" />
//         <br />
//         <Button>Add to Cart</Button>
//         <p style={{ fontSize: '0.85rem', marginTop: '10px' }}>* Excludes certain TLDs and recently renewed domains</p>
//       </Section>

//       <Section>
//         <h2>Network Features</h2>
//         <Grid>
//           <FeatureCard>
//             <h3>Network Infrastructure</h3>
//             <p>
//               Over 130GBPS of resilient diverse connectivity from premium providers.
//               100% Juniper core routing, HP switching, dual rack drops, real-time monitoring.
//             </p>
//           </FeatureCard>
//           <FeatureCard>
//             <h3>Network Resilience</h3>
//             <p>
//               Redundant fibre entry, multiple data centres, dual cabling—ensuring optimal uptime.
//             </p>
//           </FeatureCard>
//           <FeatureCard>
//             <h3>Connectivity Providers</h3>
//             <p>
//               Blend of NTT, TalkTalk, Level 3, LINX, Virgin Media, and more — only 50% network capacity used.
//             </p>
//           </FeatureCard>
//           <FeatureCard>
//             <h3>LINX Peering</h3>
//             <p>
//               Access to major networks including AT&T, BT, Google, BBC, Yahoo, through the LINX exchange.
//             </p>
//           </FeatureCard>
//         </Grid>
//       </Section>
//     </>
//   );
// };

// export default DomainTransferPage;




// import React, { useContext, useState } from 'react';
// import styled from 'styled-components';
// import transferHero from '../Images/domaintransferimg.jpg'; // Replace with actual image path
// import useAnimateOnScroll from './useAnimateOnScroll';
// import 'animate.css'
// import { useNavigate } from 'react-router-dom';
// import Swal from 'sweetalert2';
// import DomainTransferInstructions from './DomainTransferInstructions';
// import { Context } from './Context';

// const Hero = styled.section`
//   background-image: url(${transferHero});
//   background-size: cover;
//   background-position: center;
//   color: white;
//   padding: 120px 20px;
//   text-align: center;
//   position: relative;

//   &::before {
//     content: '';
//     position: absolute;
//     top: 0;
//     left: 0;
//     width: 100%;
//     height: 100%;
//     background: rgba(0, 0, 0, 0.5);
//     z-index: 0;
//   }

//   > * {
//     position: relative;
//     z-index: 1;
//   }
// `;

// const HeroTitle = styled.h1`
//   font-size: 3rem;
//   margin-bottom: 20px;
//   text-shadow: 2px 2px 6px rgba(0, 0, 0, 0.6);
//   text-transform: uppercase;
// `;

// const BodyWrapper = styled.div`
//   position: relative;
//   overflow: hidden;
//   background: linear-gradient(to right, #e0eafc, #cfdef3);
//   padding: 80px 20px;
//   z-index: 0;
// `;

// const Blob = styled.div`
//   position: absolute;
//   border-radius: 50%;
//   opacity: 0.4;
//   z-index: 0;
//   filter: blur(100px);
//   transform: rotate(${props => props.rotate || '0deg'});
//   animation: float 10s ease-in-out infinite alternate;

//   @keyframes float {
//     from {
//       transform: translateY(0) rotate(${props => props.rotate || '0deg'});
//     }
//     to {
//       transform: translateY(-30px) rotate(${props => props.rotate || '0deg'});
//     }
//   }
// `;

// const Blob1 = styled(Blob)`
//   top: -150px;
//   left: -150px;
//   width: 400px;
//   height: 400px;
//   background: radial-gradient(circle at center, #00d1ff, #007bff);
// `;

// const Blob2 = styled(Blob)`
//   bottom: -120px;
//   right: -120px;
//   width: 300px;
//   height: 300px;
//   background: radial-gradient(circle at center, #ff6ec4, #7873f5);
// `;

// const Blob3 = styled(Blob)`
//   top: 50%;
//   left: 50%;
//   transform: translate(-50%, -50%);
//   width: 500px;
//   height: 500px;
//   background: radial-gradient(circle at center, #00ffb3, #0066ff);
//   opacity: 0.2;
// `;

// const Section = styled.section`
//   padding: 60px 20px;
//   max-width: 1100px;
//   margin: auto;
//   text-align: center;
//   display:flex;
//   flex-direction:column;
//   justify-content:center;
//   align-items:center;

//   h2 {
//     color: #2B32B2;
//     font-size: 2rem;
//   }
// `;

// const Input = styled.input`
//   padding: 12px;
//   margin: 0px;
//   border: 1px solid #ccc;
//   border-radius: 5px;
//   width: 250px;
// `;

// const Button = styled.button`
//   background-color: #007bff;
//   color: white;
//   padding: 12px 25px;
//   margin-top: 15px;
//   border: none;
//   border-radius: 5px;
//   cursor: pointer;
//   font-size: 1rem;
//   transition: background 0.3s;

//   &:hover {
//     background-color: #0056b3;
//   }
// `;

// const Grid = styled.div`
//   display: grid;
//   grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
//   gap: 30px;
//   margin-top: 40px;
// `;

// const FeatureCard = styled.div`
//   background: #f8f9fa;
//   padding: 25px;
//   border-radius: 10px;
//   box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
//   text-align: left;

//   h3 {
//     font-size: 1.25rem;
//     color: #007bff;
//   }

//   p {
//     font-size: 0.95rem;
//     color: #333;
//     margin-top: 10px;
//   }
// `;


// const Select = styled.select`
//   padding: 5px;
//   // width: 100%;
//   // border-radius: 10px;
//   border: 1px solid #cbd5e1;
//   font-size: 1rem;
// `;

// const Div = styled.div`
//   p{
//     transform:translate(0%, 80%);
//     color:#007bff;
//     font-weight:bold;
//   }
// `


// const DomainTransferPage = () => {
//   const heroTitleAnim = useAnimateOnScroll('animate__fadeInDown animate__slower');
//   const heroSubtitleAnim = useAnimateOnScroll('animate__fadeInUp animate__slower');
//   const tldTitleAnim = useAnimateOnScroll('animate__fadeInUp animate__slower');
//   const pricingTitle1 = useAnimateOnScroll('animate__fadeInUp animate__slower');
//   const pricingTitle2 = useAnimateOnScroll('animate__fadeInUp animate__slower');
//   const pricingTitle3 = useAnimateOnScroll('animate__fadeInUp animate__slower');


//   const [domain, setDomain] = useState("");
//   const [tld, setTld]=useState('');
//   const [eppCode, setEppCode] = useState("");
//   const navigate = useNavigate();
//   const domaintype = 'register'

//   const {domainPricings} = useContext(Context);

//   const fullDomain = domain+tld



//   const checkDomainAvailability = async () => {
//     if (!domain) {
//       Swal.fire({ icon: "warning", text: "Please enter a domain." });
//       return;
//     }


//      if (!eppCode) {
//       Swal.fire({ icon: "warning", text: "Please enter a epp code." });
//       return;
//     }


//     Swal.fire({
//       title: "Checking domain...",
//       text: "Please wait while we check the domain.",
//       allowOutsideClick: false,
//       didOpen: () => {
//         Swal.showLoading();
//       },
//     });

//     try {
//       const res = await fetch("https://www.elexdonhost.com/api_elexdonhost/check_domain.php", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ domain: fullDomain, type: domaintype }),
//       });

//       const data = await res.json();

//       if (domaintype === "register") {
//         if (data.available) {
//           // setDomainStatus("available");
//           Swal.fire({
//             // icon: "success",
//             // title: "Domain Available",
//             text: " The domain is not yet registered.",
//           });
//         } else {
//           // setDomainStatus("unavailable");
//           Swal.fire({
//             // icon: "error",
//             // title: "Domain Unavailable",
//             text: "The domain is registered.",
//             confirmButtonText:"Proceed to transfer",
//             showCancelButton:true,
//           }).then((result)=>{
//             if(result.isConfirmed){
//               navigate(`/domaintransfercheckout/${domain}${tld}/${eppCode}/${domain}/${tld}`)
//             }
//           })
          
//           ;
//         }
//       } else if (domaintype === "transfer" || domaintype === "owndomain") {
//         if (data.available) {
        
//           Swal.fire({
//             icon: "error",
//             title: "Domain Not Registered",
//             text: "This domain is not registered and cannot be transferred or used as your own.",
//           });
//         } else {
//           // setDomainStatus("available");
//           Swal.fire({
//             icon: "success",
//             title: "Domain Registered",
//             text: "The domain is registered and can be transferred or used.",
//           });
//         }
//       } else {
//         // setDomainStatus("error");
//         Swal.fire({
//           icon: "error",
//           title: "Error",
//           text: "Invalid domain type selected.",
//         });
//       }
//     } catch (err) {
//       console.error("Domain check error:", err);
//       // setDomainStatus("error");
//       Swal.fire({
//         icon: "error",
//         title: "Error",
//         text: "There was an error checking the domain. Please try again.",
//       });
//     } finally {
//       // setCheckingDomain(false);
//     }
//   };




//   return (
//     <>
//       <Hero>
//         <HeroTitle ref={heroTitleAnim.ref} className={heroTitleAnim.className}>
//           Elexdon Host Domain Transfer
//         </HeroTitle>
//         <p ref={heroSubtitleAnim.ref} className={heroSubtitleAnim.className}>
//           Transfer now to extend your domain by 1 year!*
//         </p>
//       </Hero>

//       <BodyWrapper>
//         <Blob1 />
//         <Blob2 />
//         <Blob3 />


// <DomainTransferInstructions/>

//         <Section>
//           <h2 ref={tldTitleAnim.ref} className={tldTitleAnim.className}>Single Domain Transfer</h2>
// <Div>


//           <p>Enter domain without tld</p>
//          <Input placeholder="eg: elexdonhost" value={domain} onChange={(e) => setDomain(e.target.value)} />
//   </Div>        

// <Div>
//           <p>Select tld</p>
//           <Select
//                 name="tld"
//                 required
//                 onChange={(e)=>setTld(e.target.value)}
//                 value={tld}

//               >
//                 <option >-- Select tld --</option>
//                 {domainPricings.map((d)=>(
//                   <option key={d.domain} value={d.domain}>{d.domain}</option>
//                 ))}
//               </Select>
// </Div>

// <Div>
//               <p>Enter Epp code / Auth code</p>
//       <Input placeholder="EPP Code / Auth Code" value={eppCode} onChange={(e) => setEppCode(e.target.value)} />
//  </Div>    
//           <br />
//           <Button onClick={checkDomainAvailability}>Check</Button>
//           <p style={{ fontSize: '0.85rem', marginTop: '10px' }}>
//             * Excludes certain TLDs and recently renewed domains
//           </p>
//         </Section>

//         <Section>
//           <h2>Network Features</h2>
//           <Grid>
//             <FeatureCard ref={pricingTitle1.ref} className={pricingTitle1.className}>
//               <h3>Network Infrastructure</h3>
//               <p>
//                 Over 130GBPS of resilient diverse connectivity from premium providers.
//                 100% Juniper core routing, HP switching, dual rack drops, real-time monitoring.
//               </p>
//             </FeatureCard>
//             <FeatureCard ref={pricingTitle2.ref} className={pricingTitle2.className}>
//               <h3>Network Resilience</h3>
//               <p>
//                 Redundant fibre entry, multiple data centres, dual cabling—ensuring optimal uptime.
//               </p>
//             </FeatureCard>
//             <FeatureCard ref={pricingTitle3.ref} className={pricingTitle3.className}>
//               <h3>Connectivity Providers</h3>
//               <p>
//                 Blend of NTT, TalkTalk, Level 3, LINX, Virgin Media, and more — only 50% network capacity used.
//               </p>
//             </FeatureCard>
//             <FeatureCard>
//               <h3>LINX Peering</h3>
//               <p>
//                 Access to major networks including AT&T, BT, Google, BBC, Yahoo, through the LINX exchange.
//               </p>
//             </FeatureCard>
//           </Grid>
//         </Section>
//       </BodyWrapper>
//     </>
//   );
// };

// export default DomainTransferPage;





import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import transferHero from '../Images/domaintransferimg.jpg'; 
import useAnimateOnScroll from './useAnimateOnScroll';
import 'animate.css';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import DomainTransferInstructions from './DomainTransferInstructions';
import { Context } from './Context';
import { FaArrowRight, FaShieldAlt, FaRocket, FaGlobeAfrica, FaExchangeAlt } from 'react-icons/fa';

const Hero = styled.section`
  background-image: linear-gradient(
      135deg,
      rgba(0, 0, 0, 0.7) 0%,
      rgba(0, 0, 0, 0.7) 100%
    ),
    url(${transferHero});
  background-size: cover;
  background-position: center;
  color: #0f172a;
  padding: 80px 20px;
  text-align: center;
  border-bottom: 1px solid #eae2f8;
  margin-bottom: 40px;
`;

const BadgeHeader = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 14px;
  background: rgba(79, 70, 229, 0.08);
  border-left: 3px solid white;
  background: linear-gradient(135deg, white, white);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 12px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 16px;

  svg {
    -webkit-text-fill-color: initial;
    color: white;
  }
`;

const HeroTitle = styled.h1`
  font-size: clamp(2.2rem, 4vw, 3rem);
  margin: 0 0 16px 0;
  text-transform: uppercase;
  font-weight: 900;
  color: white;
  letter-spacing: 0.5px;

  span {
    background: linear-gradient(135deg, #4f46e5, #9333ea);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    color:white;
  }
`;

const HeroSubtitle = styled.p`
  font-size: 1.15rem;
  margin: 0;
  color: white;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.6;
`;

const BodyWrapper = styled.div`
  background: #fcfbfe;
  padding: 0 20px 80px 20px;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 50px;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
`;

const Section = styled.section`
  padding: 40px;
  background: transparent;

  h2 {
    color: #102a43;
    font-size: 1.8rem;
    margin: 0 0 30px 0;
    text-align: center;
    font-weight: 900;

    span {
      background: linear-gradient(135deg, #4f46e5, #9333ea);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
`;

const FormRow = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr) auto;
  gap: 20px;
  align-items: end;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  label {
    font-size: 0.95rem;
    font-weight: 700;
    color: #102a43;
  }
`;

const Input = styled.input`
  padding: 14px 16px;
  margin: 0;
  border: 1px solid #dcd6f7;
  border-radius: 10px;
  font-size: 1rem;
  background: #ffffff;
  color: #0f172a;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.02);
  transition: all 0.2s ease;

  &:focus {
    outline: none;
    border-color: #4f46e5;
    box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.15);
  }

  &::placeholder {
    color: #94a3b8;
  }
`;

const Select = styled.select`
  padding: 14px 16px;
  border: 1px solid #dcd6f7;
  border-radius: 10px;
  font-size: 1rem;
  background: #ffffff;
  color: #4f46e5;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(79, 70, 229, 0.03);
  transition: all 0.2s ease;

  &:focus {
    outline: none;
    border-color: #4f46e5;
    box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.15);
  }

  option {
    color: #0f172a;
    background: #ffffff;
  }
`;

const Button = styled.button`
  background: linear-gradient(135deg, #4f46e5 0%, #9333ea 100%);
  color: white;
  padding: 14px 28px;
  margin: 0;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 52px;
  box-shadow: 0 6px 20px rgba(79, 70, 229, 0.3);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(147, 51, 234, 0.4);
    background: linear-gradient(135deg, #4338ca 0%, #7e22ce 100%);
  }
`;

const FeaturesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

const FeatureItem = styled.div`
  padding: 24px;
  border-left: 4px solid #4f46e5;
  background: rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(10px);
  border-radius: 0 12px 12px 0;
  border-top: 1px solid #eae2f8;
  border-right: 1px solid #eae2f8;
  border-bottom: 1px solid #eae2f8;
  display: flex;
  flex-direction: column;
  gap: 12px;
  box-shadow: 0 10px 25px rgba(79, 70, 229, 0.04);

  h3 {
    font-size: 1.2rem;
    color: #102a43;
    margin: 0;
    font-weight: 800;
  }

  p {
    font-size: 0.95rem;
    color: #61758a;
    margin: 0;
    line-height: 1.6;
  }
`;

const DomainTransferPage = () => {
  const heroTitleAnim = useAnimateOnScroll('animate__fadeInDown animate__slower');
  const heroSubtitleAnim = useAnimateOnScroll('animate__fadeInUp animate__slower');
  const tldTitleAnim = useAnimateOnScroll('animate__fadeInUp animate__slower');

  const [domain, setDomain] = useState("");
  const [tld, setTld] = useState('');
  const [eppCode, setEppCode] = useState("");
  const navigate = useNavigate();
  const domaintype = 'register';

  const { domainPricings } = useContext(Context);
  const fullDomain = domain + tld;

  const checkDomainAvailability = async () => {
    if (!domain) {
      Swal.fire({ icon: "warning", text: "Please enter a domain." });
      return;
    }

    if (!eppCode) {
      Swal.fire({ icon: "warning", text: "Please enter an EPP code." });
      return;
    }

    Swal.fire({
      title: "Checking domain...",
      text: "Please wait while we check the domain.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      const res = await fetch("https://www.elexdonhost.com/api_elexdonhost/check_domain.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ domain: fullDomain, type: domaintype }),
      });

      const data = await res.json();

      if (domaintype === "register") {
        if (data.available) {
          Swal.fire({ text: "The domain is not yet registered." });
        } else {
          Swal.fire({
            text: "The domain is registered.",
            confirmButtonText: "Proceed to transfer",
            showCancelButton: true,
          }).then((result) => {
            if (result.isConfirmed) {
              navigate(`/domaintransfercheckout/${domain}${tld}/${eppCode}/${domain}/${tld}`);
            }
          });
        }
      } else {
        Swal.fire({ icon: "error", title: "Error", text: "Invalid domain type selected." });
      }
    } catch (err) {
      console.error("Domain check error:", err);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "There was an error checking the domain. Please try again.",
      });
    }
  };

  return (
    <>
      <Hero>
        <BadgeHeader>
          <FaExchangeAlt /> Secure Migration
        </BadgeHeader>
        <HeroTitle ref={heroTitleAnim.ref} className={heroTitleAnim.className}>
          Seamless Domain <span>Transfer</span>
        </HeroTitle>
        <HeroSubtitle ref={heroSubtitleAnim.ref} className={heroSubtitleAnim.className}>
          Transfer your domains to Elexdon Host effortlessly and extend your registration by 1 year!*
        </HeroSubtitle>
      </Hero>

      <BodyWrapper>
        <DomainTransferInstructions />

        <Section>
          <h2 ref={tldTitleAnim.ref} >
            Single Domain <span>Transfer</span>
          </h2>
          
          <FormRow>
            <InputGroup>
              <label>Domain name (without TLD)</label>
              <Input placeholder="eg: elexdonhost" value={domain} onChange={(e) => setDomain(e.target.value)} />
            </InputGroup>

            <InputGroup>
              <label>Select TLD extension</label>
              <Select name="tld" required onChange={(e) => setTld(e.target.value)} value={tld}>
                <option value="">-- Select TLD --</option>
                {domainPricings && domainPricings.map((d) => (
                  <option key={d.domain} value={d.domain}>{d.domain}</option>
                ))}
              </Select>
            </InputGroup>

            <InputGroup>
              <label>EPP / Auth code</label>
              <Input placeholder="Enter Auth Code" value={eppCode} onChange={(e) => setEppCode(e.target.value)} />
            </InputGroup>

            <Button onClick={checkDomainAvailability}>
              Check Transfer <FaArrowRight />
            </Button>
          </FormRow>

          <p style={{ fontSize: '0.85rem', margin: '20px 0 0 0', color: '#61758a', textAlign: 'center' }}>
            * Excludes certain TLDs and recently renewed domains
          </p>
        </Section>

        <Section>
          <h2>Enterprise <span>Network Features</span></h2>
          <FeaturesGrid>
            <FeatureItem>
              <h3>Infrastructure</h3>
              <p>Over 130GBPS resilient diverse connectivity with 100% Juniper core routing.</p>
            </FeatureItem>
            <FeatureItem>
              <h3>Resilience</h3>
              <p>Redundant fibre entry, multiple data centres, and dual cabling ensuring uptime.</p>
            </FeatureItem>
            <FeatureItem>
              <h3>Providers</h3>
              <p>Blend of NTT, TalkTalk, Level 3, LINX, and Virgin Media capacity channels.</p>
            </FeatureItem>
            <FeatureItem>
              <h3>LINX Peering</h3>
              <p>Direct access to major networks including AT&T, BT, Google, and BBC via exchange.</p>
            </FeatureItem>
          </FeaturesGrid>
        </Section>
      </BodyWrapper>
    </>
  );
};

export default DomainTransferPage;